import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Tooltip from 'react-tooltip'

import { deleteLot, updateLot } from '../../actions'

const initialState = {
  name: '',
  renaming: false
}

class Lotline extends Component {
  constructor() {
    super()
    this.state = initialState
  }

  showHideRename() {
    this.setState({
      name: this.props.l.name,
      renaming: !this.state.renaming
    })
  }

  renameLot() {
    const l = this.props.l
    const s = this.state
    this.props.updateLot({
      id: l.id,
      extraordinary: l.extraordinary,
      name: s.name
    })
  }

  chageStraordinary() {
    const l = this.props.l
    this.props.updateLot({
      id: l.id,
      extraordinary: l.extraordinary === 1 ? 0 : 1,
      name: l.name
    })
  }

  canBeSaved() {
    const s = this.state
    const p = this.props
    if (s.name === p.l.name || s.name.length === 0) {
      return true
    }
    return p.lots.filter((x) => x.name === s.name).length > 0
  }

  componentDidUpdate(prevProps, prevState) {
    const p = prevProps.detections
    const c = this.props.detections
    if (p.loading && !c.loading) {
      this.setState({ ...initialState })
    }
  }

  render() {
    const s = this.state
    const l = this.props.l
    return (
      <>
        <Tooltip id='managers' effect='solid'>
          Gestori
        </Tooltip>
        <Tooltip id='inspectors' effect='solid'>
          Ispettori
        </Tooltip>
        <Tooltip id='maintainers' effect='solid'>
          Manutentori
        </Tooltip>
        <Tooltip id='detections' effect='solid'>
          Anomalie presenti
        </Tooltip>
        <Tooltip id='ordinary' effect='solid'>
          Sposta in manutenzione ordinaria
        </Tooltip>
        <Tooltip id='extraordinary' effect='solid'>
          Sposta in manutenzione straordinaria
        </Tooltip>
        <ul className='ul-detections bb'>
          <li className='move'>
            {l.id > 0 && (
              <button
                className='lnk-extraordinary'
                onClick={() => this.chageStraordinary()}
                data-tip=''
                data-for={l.extraordinary === 0 ? 'extraordinary' : 'ordinary'}
              >
                {l.extraordinary === 0 && l.id > 0 && (
                  <i className='far fa-arrow-alt-circle-up'></i>
                )}
                {l.extraordinary === 1 && l.id > 0 && (
                  <i className='far fa-arrow-alt-circle-down'></i>
                )}
              </button>
            )}
          </li>
          <li className='name'>
            {!s.renaming && (
              <Link
                to={'/detections/' + l.id + '/' + l.name}
                className='lnk-lot-go'
              >
                {l.name}
              </Link>
            )}
            {s.renaming && (
              <div className='container-edit-inline'>
                <input
                  type='tex'
                  value={s.name}
                  onChange={(event) =>
                    this.setState({ name: event.target.value })
                  }
                />
                <button
                  className='lnk-edit-inline'
                  disabled={this.canBeSaved()}
                  onClick={() => this.renameLot()}
                >
                  <i className='far fa-save'></i>
                </button>
                <button
                  className='lnk-edit-inline'
                  onClick={() => this.showHideRename()}
                >
                  <i className='fas fa-times'></i>
                </button>
              </div>
            )}
          </li>
          <li>
            <span data-tip='' data-for='managers'>
              {l.id > 0 ? l.managers : ''}
            </span>
          </li>
          <li>
            <span data-tip='' data-for='inspectors'>
              {l.id > 0 ? l.inspectors : ''}
            </span>
          </li>
          <li>
            <span data-tip='' data-for='maintainers'>
              {l.id > 0 ? l.maintainers : ''}
            </span>
          </li>
          <li>
            <span data-tip='' data-for='detections'>
              {l.count}
            </span>
          </li>
          <li className='btn'>
            {l.id > 0 && (
              <button
                className='lnk-edit-lot'
                onClick={() => this.showHideRename()}
              >
                {!s.renaming && 'rinomina'}
                {s.renaming && 'annulla'}
              </button>
            )}
          </li>
          <li className='btn'>
            {l.id > 0 && (
              <button
                className='lnk-edit-lot'
                disabled={
                  l.count > 0 ||
                  l.maintainers > 0 ||
                  l.inspectors > 0 ||
                  l.managers > 0
                }
                onClick={() => this.props.deleteLot({ id: l.id })}
              >
                elimina
              </button>
            )}
          </li>
        </ul>
      </>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, { deleteLot, updateLot })(Lotline)
